import React from 'react';

export const InputOrTextarea = (props, ref) => {
    if(props.multiline) {
        const { multiline, ...restProps } = props;
        return <textarea aria-multiline='true' ref={ref} {...restProps}></textarea>;
    }

    const { multiline, type = 'text', ...restProps } = props;

    /* istanbul ignore next */
    const onWheel = (e) => {
        const el = e.target;
        if(el !== null && el.type === 'number') {
            el.blur();
            e.stopPropagation();
            setTimeout(() => {
                el.focus({ preventScroll: true });
            }, 0);
        }
    };

    return (
        <input onWheel={onWheel} type={type} ref={ref} {...restProps} placeholder={restProps.placeholder ? restProps.placeholder : ''} />
    );
};